import { useQuery } from "react-query";
import { API_URL } from "../../../../BaseUrlApi/Url";
import API from "@Config/axios";

export const useGetDistrict = (districtId) => {
  return useQuery(
    ["district", districtId],
    async () => {
      if (!districtId) return null;
      const response = await API.get(
        `${API_URL}/regions/districts?id=${districtId}`
      );
      return response.data.districts?.name || "-";
    },
    { enabled: !!districtId }
  );
};
